
export const BOOLEAN_DICTIONARY: Record<number, boolean> = {
    0: false,
    1: true,
}